/* ProductCompatibilitySummaryV2.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _6 = "._syaz1k3w{color:var(--ds-text-subtle)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RichTooltip } from '@atlassian/mpac-ui';
import React from 'react';
import { getProductCompatibilityList } from '../AppListing.utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _5 = "._18s81dzv{margin:var(--ds-space-100) var(--ds-space-150)}";
const _4 = "._19bvidpf{padding-left:0}";
const _3 = "._n3tdidpf{padding-bottom:0}";
const _2 = "._u5f3idpf{padding-right:0}";
const _ = "._ca0qidpf{padding-top:0}";
export const CompatiblilityList = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _18s81dzv", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CompatiblilityList.displayName = 'CompatiblilityList';
}
export const PreText = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1k3w", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PreText.displayName = 'PreText';
}
export const AndMoreText = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1k3w", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AndMoreText.displayName = 'AndMoreText';
}
export const INITIAL_COMPATIBILITIES_COUNT = 3;
const ProductCompatibilitySummaryV2 = props => {
  const {
    cloudCompatibleProducts,
    serverCompatibleProducts,
    dataCenterCompatibleProducts
  } = props;
  const allCompatibilities = [...cloudCompatibleProducts, ...serverCompatibleProducts, ...dataCenterCompatibleProducts];
  const compatibilityList = getProductCompatibilityList(allCompatibilities);
  const compatibilityText = compatibilityList.slice(0, INITIAL_COMPATIBILITIES_COUNT).join(', ').trim();
  const tooltipContent = compatibilityList.length > INITIAL_COMPATIBILITIES_COUNT ? /*#__PURE__*/_jsx(CompatiblilityList, {
    children: compatibilityList.slice(INITIAL_COMPATIBILITIES_COUNT).map(item => /*#__PURE__*/_jsx("li", {
      children: item
    }, item))
  }) : null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PreText, {
      children: "works with"
    }), " ".concat(compatibilityText), !!tooltipContent && /*#__PURE__*/_jsxs(_Fragment, {
      children: [" ", /*#__PURE__*/_jsx(RichTooltip, {
        content: tooltipContent,
        children: /*#__PURE__*/_jsx(AndMoreText, {
          children: "and more"
        })
      })]
    })]
  });
};
export default ProductCompatibilitySummaryV2;